<template>
  <div class="banner">
    <!-- <div class="mm"></div> -->
    <div class="banner-img">
      <img v-if="img" :src="img" />
      <img v-else src="../assets/img/bg-top.jpg" alt="">
    </div>
    <div class="banner-title animate__animated animate__shakeX">
      <p>{{title}}</p>
      <p class="title-eng">{{ titleEng }}</p>
      <div class="line_bottom" v-if="$route.name !== 'newsdetails'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    titleEng: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: ""
    }
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: calc(100vw / 5.4);
  // height: auto;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(10px);

    // background-image: url(../assets/img/bgtop.jpg);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    //width: 1240px;
    // height: 100%;
    width: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 45px;
    font-weight: bold;
    // line-height: 300px;
    text-align: center;
    width: 100%;
    height: 100%;
    .title-eng {
      font-size: 28px;
    }
    .line_bottom {
      width: 55px;
      height: 7px;
      background: linear-gradient(90deg, #3364ff 0%, #7994ff 100%);
      border-radius: 4px;
      margin: 10px 0 16px 0;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
}

@media screen and (max-width: 997px) {
  .banner {
    height: calc(100vw / 3.5);
    &-title {
      font-size: 30px;
      .title-eng {
        font-size: 20px;
      }
    }
  }
}
</style>